import(/* webpackMode: "eager" */ "/www/beluxe-frontend/src/components/CookieBanner/index.tsx");
import(/* webpackMode: "eager" */ "/www/beluxe-frontend/src/components/BeLuxe/ProgressBarPage/index.tsx");
import(/* webpackMode: "eager" */ "/www/beluxe-frontend/src/providers/RootProvider.tsx");
import(/* webpackMode: "eager" */ "/www/beluxe-frontend/src/app/globals.scss")